import { LinkRendererValue } from "@src/types/custom_renderer_types";
import { CustomCellRendererProps } from "ag-grid-react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

interface LinkRendererProps {
  props: CustomCellRendererProps;
}

const LinkRenderer: React.FC<LinkRendererProps> = ({ props }) => {
  const navigate = useNavigate();

  const { text, path }: LinkRendererValue = props.value;

  function onClick(): void {
    navigate(path);
  }

  return (
    <Button type="link" onClick={onClick}>
      {text}
    </Button>
  );
};

export default LinkRenderer;
